import { AntdLayout, Card, Col, Row, Typography } from '@pankod/refine-antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useLogin } from 'hooks/useLogin';
import { LoginInput } from 'models/auth';

import { LoginForm } from './LoginForm';

import styles from './index.module.scss';

const { Title } = Typography;

export const LoginPage: React.FC = () => {
  const { t } = useTranslation();

  const { login } = useLogin();

  const CardTitle = (
    <Title level={3} className="title">
      {t('pages.login.title')}
    </Title>
  );

  return (
    <AntdLayout className={styles.layout}>
      <Row className="h-screen" justify="center" align="middle">
        <Col xs={22}>
          <div className={styles.container}>
            <div className={styles.imageContainer}>
              <img src="/images/svg/logo.svg" alt="Exo Create" />
            </div>
            <Card
              bordered={false}
              title={CardTitle}
              headStyle={{ borderBottom: 0 }}
            >
              <LoginForm onSubmit={login as (input: LoginInput) => void} />
            </Card>
          </div>
        </Col>
      </Row>
    </AntdLayout>
  );
};
